import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';

const CONTRACTS_STATS_FIELDS = {
    APPLICATION_BREAKDOWN: {
        key: 'applicationBreakdown',
        type: FIELD_TYPES.OBJECT
    },
    CB_VERSION_BREAKDOWN: {
        key: 'cbVersionBreakdown',
        type: FIELD_TYPES.OBJECT
    }
};

export default CONTRACTS_STATS_FIELDS;